// 资讯订阅的确认页 / 退订页（/insights/confirm、/insights/unsubscribe），链接来自邮件。
// 页面打开时不自动提交：邮箱的安全扫描会预先打开链接，必须由本人点按钮才算数。
import React, { useState } from 'react';
import { Button, Link } from '@chakra-ui/react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { LegalShell, P } from './LegalShell';
import { readLang, writeLang } from './siteLang';
import { confirmSubscription, unsubscribeInsights } from './siteForms';

const COPY = {
  en: {
    confirm: {
      title: 'Confirm your subscription',
      intro: 'Click the button to start receiving Bizsprite Insights by email.',
      cta: 'Confirm subscription',
      done: 'You are subscribed. A welcome email is on its way, and every email has an unsubscribe link.',
    },
    unsubscribe: {
      title: 'Unsubscribe',
      intro: 'Click the button to stop receiving Bizsprite Insights emails.',
      cta: 'Unsubscribe',
      done: 'You are unsubscribed and will not receive further Insights emails. You can sign up again on our website at any time.',
    },
    invalid_token: 'This link is not valid. It may have been replaced by a newer email; please use the latest one.',
    token_expired: 'This confirmation link has expired. Sign up again on our website to get a new one.',
    error: 'Something went wrong. Please try again later, or email support@bizsprite.com.',
    back: 'Back to Bizsprite',
  },
  zh: {
    confirm: {
      title: '确认订阅',
      intro: '点下面的按钮，确认用这个邮箱接收 Bizsprite 资讯。',
      cta: '确认订阅',
      done: '订阅成功。欢迎邮件已经发出，之后每封邮件里都有退订链接。',
    },
    unsubscribe: {
      title: '退订',
      intro: '点下面的按钮，不再接收 Bizsprite 资讯邮件。',
      cta: '退订',
      done: '已退订，之后不会再收到资讯邮件。想重新订阅，可以随时在官网再填一次邮箱。',
    },
    invalid_token: '这个链接无效，可能已经被新邮件里的链接替代，请使用最新一封邮件。',
    token_expired: '确认链接已过期，请在官网重新订阅，我们会发一封新的确认邮件。',
    error: '暂时无法处理，请稍后再试，或发邮件到 support@bizsprite.com。',
    back: '返回 Bizsprite 官网',
  },
};

export default function SiteSubscription({ mode }) {
  const [params] = useSearchParams();
  // 邮件链接带着订阅时的语言；没有时用浏览器记住的网站语言
  const [lang, setLangState] = useState(() => (['zh', 'en'].includes(params.get('lang')) ? params.get('lang') : readLang()));
  const setLang = (l) => { setLangState(l); writeLang(l); };
  const token = params.get('token') || '';
  const [state, setState] = useState(token ? 'idle' : 'invalid_token');
  const t = COPY[lang] || COPY.en;
  const page = t[mode];

  const submit = () => {
    setState('working');
    (mode === 'confirm' ? confirmSubscription(token) : unsubscribeInsights(token))
      .then(() => setState('done'))
      .catch((e) => setState(['invalid_token', 'token_expired'].includes(e.message) ? e.message : 'error'));
  };

  return (
    <LegalShell lang={lang} setLang={setLang} title={page.title}>
      {state === 'done' ? (
        <P role="status">{page.done}</P>
      ) : ['invalid_token', 'token_expired', 'error'].includes(state) ? (
        <P role="alert" color="red.600">{t[state]}</P>
      ) : (
        <>
          <P>{page.intro}</P>
          <Button colorScheme="blue" onClick={submit} isLoading={state === 'working'}>{page.cta}</Button>
        </>
      )}
      <Link as={RouterLink} to="/" color="blue.600" fontSize="sm">{t.back}</Link>
    </LegalShell>
  );
}
